"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _system = require("@ori-ui/mui-bundle/system");
var _theme = _interopRequireDefault(require("../theme"));
const styled = (0, _system.createStyled)({
  defaultTheme: _theme.default
});
var _default = exports.default = styled;
//# sourceMappingURL=styled.js.map